import { render, staticRenderFns } from "./GoodDamageTypesInput.vue?vue&type=template&id=2233fcc2"
import script from "./GoodDamageTypesInput.vue?vue&type=script&lang=ts"
export * from "./GoodDamageTypesInput.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageTypesInput.vue?vue&type=style&index=0&id=2233fcc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports